import {customAxios} from '../../../../../infrastructure/api/CustomAxios';
import {Endpoints} from '../../../../../config/Endpoints';
import {ListFaqsApiResponse} from './ListFaqs.apiResponse';

export const ListFaqsResource = {
  list: () => {
    return customAxios.get<ListFaqsApiResponse>(Endpoints.faqs.list);
  },
};
